const definitionsMap = new Map<string, Map<string, string>>();
const loadingMap = new Map<string, Promise<void>>();

export async function loadDefinitions(url: string = "/data/es-en.dict.json"): Promise<void> {
  if (definitionsMap.has(url)) return;
  if (loadingMap.has(url)) return loadingMap.get(url)!;

  const promise = (async () => {
    const res = await fetch(url);
    const data: Record<string, string> = await res.json();
    definitionsMap.set(url, new Map(Object.entries(data)));
  })();

  loadingMap.set(url, promise);
  return promise;
}

let activeDictUrl: string = "/data/es-en.dict.json";

export function setActiveDefinitions(url: string): void {
  activeDictUrl = url;
}

/** Returns semicolon-separated translation string, or undefined if not found. */
export function getDefinitions(lemma: string): string | undefined {
  return definitionsMap.get(activeDictUrl)?.get(lemma);
}
